import {createFileRoute, lazyRouteComponent} from '@tanstack/react-router';
import {searchParams} from '../../router/search-params/search-params';

export const Route = createFileRoute('/terminal/list')({
  validateSearch: searchParams({machineId: 'string', name: 'string', page: 'int', sort: 'string', order: 'string'}),
  component: lazyRouteComponent(() => import('../../react/terminals/erp-terminal-list'), 'ErpTerminalList'),
});
